import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './Header.css'

import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link, useLocation  } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageChooser from '../LanguageChooser/LanguageChoose';
function Header() {
   const {t,i18n} = useTranslation();
  const [isSticky, setSticky] = useState(false);
 
 
  useEffect(() => {
    AOS.init();
  }, []);
 
  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = 500;
      setSticky(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const headerElement = document.getElementById('Header');

    if (headerElement) {
      if (isSticky) {
        headerElement.classList.add("Anim");
      } else {
        headerElement.classList.remove("Anim");
      }
    }
  }, [isSticky]);

  const [isClicked, setIsClicked] = useState(false);
  const spanRefFirst = useRef(null)
  const spanRefSecond = useRef(null)
  const spanRefThird = useRef(null)

  const sideMenuRef = useRef()
  
  const handleMenuClick = () => {
    handleMenuAnimations()
    if(isClicked == true){
      setTimeout(()=>{
        setIsClicked(!isClicked)
      },300)
    }
    else setIsClicked(!isClicked)
    
    
  };
  const handleMenuAnimations =()=>{
    if(isClicked == true){
      spanRefFirst.current.classList.remove("clicked")
      spanRefSecond.current.classList.remove("clicked")
      spanRefThird.current.classList.remove("clicked")

      spanRefFirst.current.classList.add("unclicked")
      spanRefSecond.current.classList.add("unclicked")
      spanRefThird.current.classList.add("unclicked")

      sideMenuRef.current.classList.remove("animate__animated", "animate__slideInRight", "animate__faster")
      
      sideMenuRef.current.classList.add("animate__animated", "animate__slideOutRight", "animate__faster")
    }else{
      spanRefFirst.current.classList.add("clicked")
      spanRefSecond.current.classList.add("clicked")
      spanRefThird.current.classList.add("clicked")

      spanRefFirst.current.classList.remove("unclicked")
      spanRefSecond.current.classList.remove("unclicked")
      spanRefThird.current.classList.remove("unclicked")
    }
  }
  const hideMenu = () =>{
    
    handleMenuAnimations()
    if(isClicked == true){
      setTimeout(()=>{
        setIsClicked(!isClicked)
      },300)
    }
    else setIsClicked(!isClicked)
    
  }

  const scrollToContact = () =>{
    const specificSection = document.getElementById('Form');
    if (specificSection) {
        
        const offset = 100; 
        const offsetPosition = specificSection.offsetTop - offset;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
  }
  const location = useLocation();
 
  
  return (
    <header className={`Header ${isSticky ? 'sticky' : ''}`} id='Header'>
      <nav className='Header-Section' aria-label="Primary">
        <div className='Header-Section-Logo'>
          <svg version="1.1" id="Layer_1" x="0px" y="0px"
            viewBox="0 0 822 166" style={{ enableBackground: "new 0 0 822 166" }} xmlSpace="preserve">
              <path d="M205.3,127c4,0,6.6,1,7.9,2.8c1.5,1.9,1.5,4.5,0.4,7.6c-1,2.8-2.7,5.3-5.2,7.3c-2.7,2.1-5.6,3.1-8.8,3.1h-6.7l-3.5,10.4
    h-5.9l10.7-31.2H205.3z M201,141.8c1.5,0,2.7-0.4,4.1-1.2c1.2-0.9,2.2-1.9,2.6-3.2c0.5-1.4,0.4-2.5-0.4-3.2
    c-0.6-0.9-1.9-1.2-3.3-1.2H198l-3,8.9H201z M240.3,127h5.9l-10.7,31.2h-5.9l4.3-12.6h-13.5l-4.2,12.6h-5.9l10.7-31.2h5.9l-4.3,12.6
    h13.4L240.3,127z M270.4,127h7.1L260,145.6l-4.3,12.6h-5.9l4.2-12.6l-4.7-18.6h7.1l2.7,12.6L270.4,127z M286.6,139.2
    c1.9,0.4,3.2,0.7,4.3,1.1c1.2,0.4,2.4,0.9,3.1,1.6c1,0.7,1.6,1.6,1.7,2.8c0.1,1.1,0,2.5-0.6,4.1c-1,3-2.8,5.3-5.7,7.2
    c-2.8,1.9-6.3,2.8-10.3,2.8c-5.2,0-8.8-1.7-10.8-5.2l4.6-5.2c0.9,1.5,2,2.6,3.6,3.3c1.6,0.7,3.1,1.1,4.7,1.1c2.1,0,3.8-0.4,5.2-1
    c1.4-0.7,2.2-1.6,2.6-2.7c0.4-1,0.1-1.9-0.6-2.5c-0.9-0.6-2.2-1.1-4.3-1.4c-4-0.7-6.7-1.7-8.1-3.3c-1.2-1.6-1.5-3.6-0.6-6.1
    c0.9-2.7,2.7-5.1,5.6-6.9c2.7-1.9,5.9-2.8,9.7-2.8c4.1,0,7.2,1.4,9.4,3.8l-4.2,5.1c-1.6-2-4.1-3-7.2-3c-1.7,0-3.3,0.2-4.6,0.9
    c-1.4,0.5-2.2,1.4-2.5,2.6c-0.4,1-0.2,1.7,0.6,2.2C282.9,138.5,284.4,138.9,286.6,139.2L286.6,139.2z M302.5,158.2h-5.9l10.7-31.2
    h5.9L302.5,158.2z M333.8,126.2c4.5,0,7.8,1.6,9.9,4.8c2.1,3.2,2.4,7.1,0.9,11.5c-1.6,4.6-4.6,8.4-8.8,11.6
    c-4.3,3.1-8.7,4.7-13.3,4.7c-4.5,0-7.8-1.6-9.8-4.8c-2.1-3.2-2.5-7.1-0.9-11.5c1.5-4.5,4.5-8.3,8.8-11.5
    C324.9,127.8,329.2,126.2,333.8,126.2L333.8,126.2z M318.3,150c1.4,2,3.5,3,6.3,3c2.8,0,5.7-1,8.4-3c2.7-2.1,4.6-4.6,5.5-7.4
    c1-2.8,0.9-5.3-0.5-7.3c-1.2-2.1-3.3-3.1-6.2-3.1c-2.8,0-5.7,1-8.5,3.1c-2.6,2-4.6,4.5-5.6,7.3C316.8,145.4,316.9,147.9,318.3,150
    L318.3,150z M351.4,127h22.3l-2.1,5.9h-8.2l-8.5,25.3h-5.9l8.5-25.3h-8.2L351.4,127z M397.5,127h5.9l-10.7,31.2h-5.9l4.3-12.6h-13.4
    l-4.3,12.6h-5.9l10.7-31.2h5.9l-4.3,12.6h13.5L397.5,127z M426.6,132.9h-13.4l-2.1,6.7h11.2l-2.1,5.9H409l-2.4,6.7H420l-1.9,5.9
    h-19.5l10.7-31.2h19.3L426.6,132.9z M447,158.2h-7.2l-3.6-10.4h-3.5l-3.6,10.4h-5.9l10.7-31.2h11.2c4,0,6.6,1,7.9,2.8
    c1.4,1.9,1.5,4.5,0.4,7.6c-0.7,2.2-2.1,4.3-4,6.2c-2,1.9-4.1,3.1-6.6,3.7L447,158.2z M437.7,132.9l-2.8,8.9h5.8
    c1.5,0,2.8-0.4,4.2-1.2c1.2-0.9,2-1.9,2.5-3.2c0.5-1.4,0.4-2.5-0.4-3.2c-0.6-0.9-1.9-1.2-3.3-1.2H437.7z M473.4,158.2l-0.5-5.9
    h-13.5l-4.2,5.9h-6.7l23.5-31.2h5.3l2.4,31.2H473.4z M463.9,146.3h8.7l-0.6-11.2L463.9,146.3z M504.5,127c4,0,6.6,1,7.9,2.8
    c1.5,1.9,1.5,4.5,0.4,7.6c-1,2.8-2.7,5.3-5.2,7.3c-2.6,2.1-5.6,3.1-8.7,3.1h-6.8l-3.5,10.4h-5.9l10.7-31.2H504.5z M500.2,141.8
    c1.5,0,2.7-0.4,4.1-1.2c1.2-0.9,2.2-1.9,2.6-3.2c0.5-1.4,0.4-2.5-0.4-3.2c-0.6-0.9-1.9-1.2-3.3-1.2h-5.9l-3,8.9H500.2z M515.4,158.2
    h-5.9l10.7-31.2h5.9L515.4,158.2z M539.7,139.2c1.9,0.4,3.2,0.7,4.5,1.1c1.1,0.4,2.2,0.9,3,1.6c1,0.7,1.6,1.6,1.7,2.8
    c0.1,1.1,0,2.5-0.6,4.1c-1,3-2.8,5.3-5.7,7.2c-2.8,1.9-6.2,2.8-10.3,2.8c-5.2,0-8.8-1.7-10.8-5.2l4.7-5.2c0.7,1.5,1.9,2.6,3.5,3.3
    s3.1,1.1,4.8,1.1c2,0,3.7-0.4,5.1-1c1.4-0.7,2.2-1.6,2.6-2.7c0.4-1,0.1-1.9-0.6-2.5c-0.9-0.6-2.2-1.1-4.3-1.4
    c-4-0.7-6.7-1.7-7.9-3.3c-1.4-1.6-1.6-3.6-0.7-6.1c1-2.7,2.8-5.1,5.6-6.9s5.9-2.8,9.8-2.8c4,0,7.1,1.4,9.3,3.8l-4.2,5.1
    c-1.6-2-4.1-3-7.2-3c-1.7,0-3.3,0.2-4.6,0.9c-1.4,0.5-2.1,1.4-2.5,2.6c-0.4,1-0.2,1.7,0.6,2.2C536,138.5,537.6,138.9,539.7,139.2
    L539.7,139.2z M558.1,127h22.3l-2.1,5.9h-8.2l-8.5,25.3h-5.9l8.7-25.3h-8.3L558.1,127z M611.2,143.3l-10.8,7.4l5.7,7.4H597l-2.5-3.1
    c-1.5,1.1-3.2,2-5.3,2.7c-2,0.7-3.8,1.1-5.6,1.1c-3.1,0-5.3-0.9-6.7-2.6c-1.2-1.7-1.5-4.1-0.5-6.9c0.7-2,1.9-3.6,3.3-5.1
    c1.7-1.4,3.5-2.5,5.1-3.2c-0.7-1.4-1.2-2.5-1.5-3.5s-0.1-2,0.1-3.1c1-2.5,2.7-4.6,5.2-6.1c2.6-1.5,5.5-2.2,8.5-2.2
    c2.8,0,5.1,0.9,6.4,2.5c1.4,1.6,1.6,3.7,0.7,6.2c-0.2,0.9-0.6,1.7-1.4,2.6c-0.5,0.7-1,1.4-1.6,1.9c-0.5,0.5-1.2,1-2.2,1.5l-2,1.1
    l-2,0.9c-0.2,0-0.5,0.1-0.6,0.1l2.8,3.8l5.3-3.5H611.2z M585.8,153c1.9,0,3.7-0.7,5.9-2.1l-4.2-6.1c-1,0.4-2.1,1-3.2,1.7
    c-0.9,0.7-1.6,1.6-1.9,2.5c-0.4,1.1-0.2,2.1,0.4,2.8S584.4,153,585.8,153L585.8,153z M591.6,139.2c4.1-1.4,6.3-2.7,6.8-4.2
    c0.2-0.9,0.1-1.7-0.6-2.2c-0.6-0.6-1.6-1-2.7-1c-1.4,0-2.5,0.2-3.5,0.9c-1.1,0.5-1.7,1.2-2,2C589.2,135.8,590,137.3,591.6,139.2
    L591.6,139.2z M617.5,127h22.3l-2.1,5.9h-8.1l-8.7,25.3H615l8.5-25.3h-8.2L617.5,127z M657.4,158.2h-7.2l-3.5-10.4h-3.6l-3.6,10.4
    h-5.9l10.7-31.2h11.2c4,0,6.6,1,7.9,2.8c1.5,1.9,1.5,4.5,0.4,7.6c-0.6,2.2-2.1,4.3-4,6.2c-2,1.9-4.1,3.1-6.6,3.7L657.4,158.2z
    M648.3,132.9l-3,8.9h5.8c1.5,0,2.8-0.4,4.2-1.2c1.2-0.9,2.1-1.9,2.5-3.2c0.5-1.4,0.4-2.5-0.4-3.2c-0.6-0.9-1.9-1.2-3.3-1.2H648.3z
    M683.8,158.2l-0.5-5.9h-13.5l-4.2,5.9h-6.7l23.5-31.2h5.3l2.4,31.2H683.8z M674.3,146.3h8.7l-0.6-11.2L674.3,146.3z M699.1,158.2
    h-5.9l10.7-31.2h5.9L699.1,158.2z M737.2,127h5.9l-10.7,31.2h-5.9l-8.2-21.6l-7.4,21.6H705l10.7-31.2h5.8l8.4,21.7L737.2,127z
    M766.3,132.9h-13.4l-2.1,6.7H762l-2.1,5.9h-11.2l-2.4,6.7h13.4l-1.9,5.9h-19.5l10.7-31.2h19.3L766.3,132.9z M786.8,158.2h-7.2
    l-3.5-10.4h-3.6l-3.6,10.4H763l10.8-31.2h11c4,0,6.6,1,7.9,2.8c1.5,1.9,1.5,4.5,0.4,7.6c-0.6,2.2-2,4.3-4,6.2
    c-2,1.9-4.1,3.1-6.6,3.7L786.8,158.2z M777.6,132.9l-3,8.9h5.9c1.4,0,2.7-0.4,4.1-1.2c1.2-0.9,2.1-1.9,2.5-3.2
    c0.5-1.4,0.4-2.5-0.4-3.2c-0.6-0.9-1.9-1.2-3.3-1.2H777.6z M292.6,47.6L277.2,110h-18.1l8.2-32.7L245.5,110h-15.2l0.7-32.7
    L216.6,110h-18.1l27.4-62.4H244l2.5,37.2l27.9-37.2H292.6z M344.2,47.6l3.7,62.4h-17.2l-0.6-10.4h-24.5L298,110h-18.5l47.7-62.4
    H344.2z M315.5,86.2h14l-0.7-17.8L315.5,86.2z M401.2,89.1l8.4,20.9h-21.2l-6.6-19.3l-3.5,0.1l-6.7,19.2h-18.1l21.6-62.4h28.6
    c8.1,0,13.4,1.9,16.2,5.7c2.8,3.7,3.1,8.8,1,15.1c-1.6,4.6-4.2,8.8-7.8,12.5C409.8,84.6,405.7,87.3,401.2,89.1L401.2,89.1z
    M392.4,75.8c2.2,0,4.5-0.6,6.3-1.7c1.9-1.1,3-2.7,3.7-5c0.7-2.2,0.6-3.8-0.4-5c-1.1-1.2-2.7-1.7-5-1.7h-8.9l-4.7,13.4H392.4z
    M434.6,110h-18.1l21.4-62.4H456L434.6,110z M509,47.6h18.1L505.8,110h-18.2l-12.5-34.2L463.3,110h-18.1l21.4-62.4h18.2l12.5,34.2
    L509,47.6z M562.5,77.3l14.4,32.7h-22.7l-10.5-26.8l-9.2,26.8h-18.2l21.6-62.4H556l-8.2,23.9l26.3-23.9h22.8L562.5,77.3z
    M602.8,55.6c8.9-6.3,18.3-9.5,27.9-9.5s16.6,3.2,21.3,9.5c4.6,6.4,5.3,14.1,2.2,23.2s-9,16.7-18.2,23.2c-8.9,6.3-18.2,9.5-27.9,9.5
    c-9.5,0-16.6-3.2-21.3-9.5c-4.5-6.4-5.3-14.1-2.2-23.2C587.7,69.7,593.9,62.1,602.8,55.6L602.8,55.6z M603.7,90.3
    c2.1,3.2,5.5,4.8,10,4.8s9.2-1.6,13.5-4.8c4.3-3.1,7.3-7.1,8.8-11.5c1.6-4.6,1.4-8.4-0.7-11.5c-2.2-3.2-5.6-4.8-10.2-4.8
    s-9.2,1.6-13.4,4.8c-4.5,3.1-7.4,6.9-8.9,11.5C601.2,83.2,601.4,87.2,603.7,90.3L603.7,90.3z M667,110l-4.3-62.4h21.2l0.9,37.4
    l26.4-37.4h21.2L685.2,110H667z M733.5,110h-18.1l21.4-62.4H755L733.5,110z M781.7,95.1c5.8,0,11.4-2.1,16.6-6.3l1.7,15.1
    c-3.6,2.4-7.7,4.2-12,5.6c-4.5,1.4-8.5,2-12.4,2c-9.9,0-17.1-3.2-21.9-9.5c-4.8-6.4-5.7-14.1-2.6-23.2c3.1-9,9.3-16.7,18.5-23.2
    c9.2-6.3,18.7-9.5,28.5-9.5c4,0,7.7,0.6,11.2,2c3.3,1.2,6.2,3.1,8.2,5.5l-12.3,15.2c-2.2-4.2-6.3-6.3-12.1-6.3
    c-5,0-9.8,1.6-14.4,4.8c-4.6,3.1-7.8,6.9-9.3,11.5c-1.6,4.5-1.2,8.4,1.4,11.5C773,93.5,776.6,95.1,781.7,95.1L781.7,95.1z
    M789.6,41.6l14.2-14.9H822l-20.2,14.9H789.6z"/>
              <path className='two' d="M2.3,159.4l149-0.9c0.6,0,1-0.3,1.2-0.9l41.9-109c0.5-1.2-0.8-2.3-1.9-1.6L1.6,156.9C0.4,157.6,0.9,159.5,2.3,159.4z"/>
              <circle class="st0" cx="132.9" cy="41.2" r="38.1"/ >
              <path className='one' d="M98.9,22.7C76.2,25.9,76.4,26.5,67,41.9c-4.4,7.8,0.6,23.2-3.9,30.5c-10,6.9-12.1,28.7-19.3,37.5
    c-8.8,5.8-7.6,19.8-13.7,26.8c-1.8,12.2,11.1-1.4,15.6-2.9c-2.2,0.3-10.1,1.7-7.5-2.7c0.8-3.1,6-7.9,8.4-9.9
    c3.5-8.3,12.2-19.9,18.5-26.4c6.4-2.5,10.3,2.3,17.1,2.4c-5.6,0.3-9.1,4.9-13.2,7.9c-2.3,3-10.3,2.7-9.1,6.9
    c5.3,1.6,24,35.1,30.9,25.9c-45.2-46-11-13.4,3.2-41.4c-0.4-3.4-5.1-10.7-11.9-13.4c-7.8-2,2.1-12.4,3.2-16.4
    c8.2,21.5,15.6,7.1,28,12.1c10.8,4.3,19.9-10.4-3.9-4.8c-4.1,0.2-9.3-1.8-13.4-1.8c-0.3-2.3-0.3-5.4-2.1-7.2
    c-1.2-2.4,0.9-7.9-1.2-10.2c-2-2.1-4.4-2-4-4c3.2-2.6,10.2-2.9,7.1-7.8c5.4-13-12.3-8.8-15.6-0.5c-6.6,0.3,0-6.2,1-9
    C84.9,32.3,101.4,28.9,98.9,22.7z"/>
          </svg>
        </div>
        <nav className='Header-Section-Nav'>
          <li  className={location.pathname === '/programs' ? 'Active-Route' : ''} >
            <Link onClick={hideMenu} to= '/programs'>{t('navbar.services')}</Link>
          </li>
          <li className={location.pathname === '/about' ? 'Active-Route' : ''}>
            <Link onClick={hideMenu} to='/about'>{t('navbar.about')}</Link>
          </li>
          <li className={location.pathname === '/blog' ? 'Active-Route' : ''}>
            <Link onClick={hideMenu}  to='/blog'>{t('navbar.blog')}</Link>
          </li>
          <li>
            <a onClick={scrollToContact}>{t('navbar.contact')}</a>
          </li>
        
          <li  className={location.pathname === '/' ? 'Active-Route' : ''}>
            <Link  to='/' >{t('navbar.home')}</Link>
          </li>
          
        
        </nav>
        <button>
          GO GYM!
        </button>
        <div className='Drop-Down'>
          <div id='nav-button' className={`background ${isClicked ? 'clicked' : ''}`}>
            <div className="menu__icon" onClick={handleMenuClick}>
              <span ref={spanRefFirst} ></span>
              <span ref={spanRefSecond} ></span>
              <span ref={spanRefThird} ></span>
            </div>
          </div>
        </div>
        {isClicked && (
            <div
              ref={sideMenuRef}
              className="ActiveDropDown animate__animated animate__slideInRight animate__faster"
            >
              <span><Link onClick={hideMenu} to="/">{t('navbar.home')}</Link></span>
              <span><Link onClick={hideMenu} to="/programs">{t('navbar.services')}</Link></span>
              <span><Link onClick={hideMenu} to="/about">{t('navbar.about')}</Link></span>
              <span><Link onClick={hideMenu} to="/blog">{t('navbar.blog')}</Link></span>
              <span onClick={scrollToContact}>{t('navbar.contact')}</span>
            </div>
        )}
       
      </nav>
    </header>
  );
}


Header.propTypes = {
  onNavClick: PropTypes.func.isRequired,
};

export default Header;
